function CountWithProvince({ provinces = [] }) {
  const stylblue = { color: "blue" };
  const stylred = { color: "red" };

  return (
    <section>
      <h5 className="mt-5">مرسولات ثبت شده به تفکیک استان</h5>
      <div className="d-flex flex-wrap justify-content-center mt-5">
        {provinces.map((item, idx) => (
          <div
            className="border border-1 border-dark rounded p-1 m-1"
            style={{
              width: "10rem",
            }}
            key={idx}
          >
            <h6
              className="text-center"
              style={item.count > 0 ? stylblue : stylred}
            >
              {item.faName}
            </h6>
            <p
              className="text-center mb-0"
              style={item.count > 0 ? stylblue : stylred}
            >
              {item.count}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CountWithProvince;
